export default __webpack_public_path__ + "static/media/mq-new-2.9fab888b.jpg";